export function emailValidation(email) {
  const re = /\S+@\S+\.\S+/;
  const result = re.test(email);
  return result;
}

export function cpfValidation(cpf) {
  cpf = cpf.replace(/\D/g, '');
  let sum;
  let rest;
  sum = 0;
  if (cpf === '00000000000') {
    return false;
  }
  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }
  rest = (sum * 10) % 11;
  if ((rest === 10) || (rest === 11)) {
    rest = 0;
  }
  if (rest !== parseInt(cpf.substring(9, 10))) {
    return false;
  }
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }
  rest = (sum * 10) % 11;
  if ((rest === 10) || (rest === 11)) {
    rest = 0;
  }
  if (rest !== parseInt(cpf.substring(10, 11))) {
    return false;
  }
  return true;
}

export function electorTitleValidator(titleNumber) {
  let resultReturn = false;
  if (titleNumber.length === 12) {
    const firstResult = firstTitleValidator(titleNumber);
    const secondResult = secondTitleValidator(titleNumber, firstResult);
    const firstChecker = parseInt(titleNumber.substring(10, 11), 10);
    const secondChecker = parseInt(titleNumber.substring(11, 12), 10);

    if (firstChecker === firstResult && secondChecker === secondResult) {
      resultReturn = true;
    }
  }
  return resultReturn;
}

function firstTitleValidator(num) {
  const num1 = num.substring(0, 1) * 2;
  const num2 = num.substring(1, 2) * 3;
  const num3 = num.substring(2, 3) * 4;
  const num4 = num.substring(3, 4) * 5;
  const num5 = num.substring(4, 5) * 6;
  const num6 = num.substring(5, 6) * 7;
  const num7 = num.substring(6, 7) * 8;
  const num8 = num.substring(7, 8) * 9;

  const soma = (num1 + num2 + num3 + num4 + num5 + num6 + num7 + num8) % 11;

  let validador = soma;

  if (validador === 10) {
    validador = 0;
  }

  return validador;
}

function secondTitleValidator(num, firstValidatedResult) {
  const num9 = num.substring(8, 9) * 7;
  const num10 = num.substring(9, 10) * 8;
  const num11 = firstValidatedResult * 9;

  let validatorResult2 = (num9 + num10 + num11) % 11;

  if (validatorResult2 === 10) {
    validatorResult2 = 0;
  }
  return validatorResult2;
}

export default { emailValidation, cpfValidation, electorTitleValidator };
